import styled from 'styled-components';

import { Typography } from 'src/typography';

const CUSTOM_BREAKPOINTS = {
  desktop: 1186,
  tablet: 1009,
  mobile: 750,
};

export const Wrapper = styled.div`
  background: var(--dcm-logged-out-cta-bg);
  border: 1px solid var(--dcm-logged-out-cta-border-color);
  border-radius: var(--dcm-logged-out-cta-border-radius);
  margin: 10px auto;
  max-width: 1200px;
`;

export const Content = styled.div`
  color: var(--dcm-logged-out-cta-text-color);
  display: flex;
  align-items: center;
  padding: 24px;

  @media (max-width: ${CUSTOM_BREAKPOINTS.mobile}px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const Heading = styled(Typography.Heading)`
  font-size: 20px;
  margin-bottom: 10px;

  @media (max-width: ${CUSTOM_BREAKPOINTS.mobile}px) {
    font-size: 18px;
    margin-bottom: 12px;
  }
`;

export const Subheading = styled(Typography.Body)`
  font-size: 16px;
  line-height: 24px;
  color: var(--dcm-logged-out-cta-subtext-color);

  @media (max-width: ${CUSTOM_BREAKPOINTS.mobile}px) {
    font-size: 14px;
    line-height: 20px;
    /* Pull this text over the gap + icon width */
    margin-right: -34px;
  }
`;

export const AlreadyHaveAccount = styled(Typography.Body)`
  color: var(--dcm-logged-out-cta-subtext-color);
  margin-top: 12px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  gap: 16px;
  padding-right: 16px;

  @media (min-width: ${CUSTOM_BREAKPOINTS.desktop}px) {
    width: 100%;
  }

  @media (max-width: ${CUSTOM_BREAKPOINTS.tablet}px) {
    padding-right: unset;
    flex-direction: column;
  }

  @media (max-width: ${CUSTOM_BREAKPOINTS.mobile}px) {
    width: 100%;
  }
`;

export const LoginButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  color: var(--dcm-logged-out-cta-link-color);
  cursor: pointer;
  font-weight: 700;
  padding: 0;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const TextContent = styled.div`
  max-width: 456px;
  padding-right: 32px;

  @media (max-width: ${CUSTOM_BREAKPOINTS.mobile}px) {
    padding-right: 0;
    max-width: 100%;
  }
`;

export const HeadingsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-grow: 1;
  gap: 16px;
`;

export const IconContainer = styled.div`
  @media (max-width: ${CUSTOM_BREAKPOINTS.mobile}px) {
    order: 3;
  }
`;

export const SignUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media (max-width: ${CUSTOM_BREAKPOINTS.tablet}px) {
    align-items: center;
  }

  @media (max-width: ${CUSTOM_BREAKPOINTS.mobile}px) {
    min-width: 100%;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;

  @media (max-width: ${CUSTOM_BREAKPOINTS.mobile}px) {
    min-width: 100%;
  }
`;

export const SocialLoginWrapper = styled.div`
  min-width: 50%;
  flex: 1;

  @media (max-width: ${CUSTOM_BREAKPOINTS.tablet}px) {
    max-width: 100%;
  }
`;
